import {
    GetFolderIdsDataType,
    CalendarIdsGetFolderIdsData,
    GetFolderIdsData,
} from '../store/schema/GetFolderIdsData';
import { assertNever } from 'owa-assert';
import { updateFolderIdsIfNeeded } from './updateFolderIdsIfNeeded';

/**
 * Certain types of calendars require updating after the calendar cache is initialized. This loading must
 * be triggered by cache consumers once on an as needed basis to avoid doing unecessary loading of uneeded calendars
 */
export async function updateFolderIdsInCalendarCache(value: GetFolderIdsData) {
    const valueType = value.loaderType;

    switch (valueType) {
        case GetFolderIdsDataType.CalendarIds:
            await updateFolderIdsIfNeeded((value as CalendarIdsGetFolderIdsData).calendarIds);
            break;
        case GetFolderIdsDataType.DefaultCalendar:
            /** the default calendar's data is loaded during the cache initialization, so no update is needed */
            break;
        default:
            assertNever(valueType);
    }
}
